/*
 * @Author: mql_pcthree@163.com tan13872711312@163.com
 * @Date: 2022-04-19 14:17:36
 * @LastEditors: mql_pcthree@163.com tan13872711312@163.com
 * @LastEditTime: 2022-05-24 09:40:05
 * @FilePath: \mei_qi_zeroweb_endlyq\src\router\home\data.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// data
const index = () => import(/* webpackChunkName: 'homeIndex' */ '@views/home/index/index')
// const MqlMiddlePage = () =>
//   import(/* webpackChunkName: 'memberList' */ '@components/core/MqlLayout/MqlMiddlePage/index')
const dataOverview = () =>
  import(/* webpackChunkName: 'dataOverview' */ '@views/home/data/dataOverview/index')
const dataEmployee = () =>
  import(/* webpackChunkName: 'dataEmployee' */ '@views/home/data/dataEmployee/index')

const routes = [
  {
    path: '/data',
    component: index,
    name: 'data',
    redirect: { name: 'homeDataEmployee' },
    hidden: true,
    // eslint-disable-next-line no-dupe-keys
    meta: {
      keepAlive: true,
      title: '员工数据',
      first: true,
      resourceCode: 'DATA_CENTER',
      icon: 'data_center',
      No: 3
    },
    children: [
      {
        path: 'employee',
        component: dataEmployee,
        name: 'homeDataEmployee',
        meta: {
          keepAlive: true,
          title: '员工数据',
          second: false,
          resourceCode: 'DATA_CENTER02',
          No: 0
        }
      },
      {
        path: 'overview',
        component: dataOverview,
        name: 'dataOverview',
        meta: {
          keepAlive: true,
          title: '数据汇总',
          second: false,
          resourceCode: 'DATA_CENTER01',
          No: 1
        }
      }
    ]
  }
]

export default {
  routes
}



// WEBPACK FOOTER //
// ./src/router/home/data.js